import React from 'react';
import { Link } from 'react-router-dom';
import Carousel from 'react-bootstrap/Carousel';

//import banner from '../assets/images/slider/banner.jpeg';
import slider1 from '../assets/images/slider/slider1.jpg';
import slider2 from '../assets/images/slider/slider1.jpg';
import slider3 from '../assets/images/slider/slider1.jpg';

const sliderModernStyles = `
  .slider_section {
    position: relative;
    min-height: 380px;
    background: linear-gradient(90deg, #b3e6fc 60%, #e0f7fa 100%);
    border-radius: 18px;
    overflow: hidden;
    margin-bottom: 2.5rem;
    box-shadow: 0 4px 24px 0 rgba(6,53,71,0.10);
    width: 100vw;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    max-width: 100vw;
    padding: 0;
  }
  .slider-gradient-overlay {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: linear-gradient(90deg, rgba(6,53,71,0.32) 30%, rgba(179,230,252,0.10) 100%);
    z-index: 1;
    pointer-events: none;
  }
  .slider_section .row {
    position: relative;
    z-index: 2;
  }
  .slider_section .detail-box {
    padding: 0;
    margin-left: 2.2rem;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 320px;
  }
  .slider_section h1 {
    font-size: 2.1rem;
    font-weight: 900;
    letter-spacing: 1.2px;
    margin-bottom: 1.1rem;
    color: #fff;
    text-shadow: 0 2px 8px rgba(6,53,71,0.18), 0 0 2px #000;
    line-height: 1.18;
  }
  .slider_section p {
    font-size: 1.13rem;
    font-weight: 500;
    color: #e3f6fc;
    margin-bottom: 1.2rem;
    line-height: 1.5;
    text-shadow: 0 1px 4px rgba(6,53,71,0.10);
  }
  .slider_section .slider-btn-modern {
    display: inline-block;
    background: linear-gradient(90deg, #7ee8fa 60%, #063547 100%);
    color: #063547;
    font-weight: 700;
    font-size: 1.08rem;
    border: none;
    border-radius: 8px;
    padding: 0.65rem 1.7rem;
    box-shadow: 0 2px 8px 0 rgba(6,53,71,0.10);
    transition: background 0.18s, color 0.18s, transform 0.18s;
    margin-top: 0.2rem;
    letter-spacing: 0.5px;
    cursor: pointer;
  }
  .slider_section .slider-btn-modern:hover {
    background: linear-gradient(90deg, #063547 60%, #7ee8fa 100%);
    color: #fff;
    transform: scale(1.06);
  }
  .slider_section .img-box {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 320px;
    padding: 0;
  }
  .slider_section .img-box img {
    max-width: 95%;
    max-height: 320px;
    border-radius: 14px;
    box-shadow: 0 2px 16px 0 rgba(6,53,71,0.13);
    object-fit: cover;
    background: #fff;
  }
  @media (max-width: 900px) {
    .slider_section {
      min-height: 260px;
      border-radius: 10px;
      padding: 0;
    }
    .slider_section .detail-box {
      padding: 0;
      margin-left: 1rem;
      min-height: 180px;
    }
    .slider_section .img-box {
      min-height: 180px;
      padding: 0;
    }
    .slider_section .img-box img {
      max-height: 180px;
      border-radius: 8px;
    }
    .slider_section h1 {
      font-size: 1.25rem;
    }
    .slider_section p {
      font-size: 0.98rem;
    }
    .slider_section .slider-btn-modern {
      font-size: 0.97rem;
      padding: 0.5rem 1.1rem;
    }
  }
`;

export default function MainSliderCarosel() {
  return (
    <div>
      <style>{sliderModernStyles}</style>
      <section className="slider_section">
        <div className="slider-gradient-overlay"></div>
        <Carousel pause={'hover'} fade indicators={false} controls={false}>
          <Carousel.Item>
            <div className="">
              <div className="row">
                <div className="col-md-6">
                  <div className="detail-box">
                    <h1>Comprehensive and Accessible Content</h1>
                    <p>
                      Diverse collection: A rich array of digital resources, including ebooks, audiobooks, articles, journals, videos, and multimedia content.<br/>
                      Easy discoverability: Intuitive search functions and metadata tagging to help users find what they need quickly.
                    </p>
                    <Link to="/aboutus" className="slider-btn-modern">Read More</Link>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="img-box">
                    <img src={slider1} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="">
              <div className="row">
                <div className="col-md-6">
                  <div className="detail-box">
                    <h1>Robust Technology Infrastructure</h1>
                    <p>
                      Reliability and scalability: A stable platform capable of handling increased user traffic and growing content collections.<br/>
                      Security: Protecting user data and intellectual property with robust security measures.
                    </p>
                    <Link to="/aboutus" className="slider-btn-modern">Read More</Link>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="img-box">
                    <img src={slider2} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="">
              <div className="row">
                <div className="col-md-6">
                  <div className="detail-box">
                    <h1>Continuous Innovation and User Focus</h1>
                    <p>
                      User-friendly interface: A clean, intuitive design that enhances user experience.<br/>
                      Adaptability: Staying up-to-date with technological advancements and user needs.
                    </p>
                    <Link to="/aboutus" className="slider-btn-modern">Read More</Link>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="img-box">
                    <img src={slider3} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </Carousel.Item>
        </Carousel>
      </section>
    </div>
  );
}
